// G2 In-App Review Configuration
// PARTNER_NAME is non-secret — it's part of the public-facing iframe URL
export const G2_PARTNER_NAME = 'DelightedOpenWrench';

// PostHog NPS survey name — must match the survey created in PostHog dashboard
export const NPS_SURVEY_NAME = 'nps-openwrench';

// NPS score threshold: scores >= this value trigger the G2 review modal
export const NPS_PROMOTER_THRESHOLD = 8;
